import React from 'react';
import { Gift, CheckCircle2, ArrowRight, Clock, Shield } from 'lucide-react';
import { offers, engineerInfo } from '../../mock';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

const OfferSection = () => {
  return (
    <section className="py-12 sm:py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <Badge className="bg-[#A69076] text-white mb-4 text-sm px-4 py-1 hover:scale-105 transition-transform">
              <Gift className="mr-1" size={14} />
              Oferta Exclusiva
            </Badge>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#073A40] mb-4">
              Comece Agora Sem Custo
            </h2>
            <p className="text-xl sm:text-2xl text-[#06323B] font-medium">
              {offers.cta}
            </p>
          </div>

          <Card className="bg-gradient-to-br from-[#073A40] to-[#06323B] border-2 border-[#A69076] shadow-2xl overflow-hidden hover:shadow-3xl transition-all duration-300">
            <div className="bg-gradient-to-r from-[#A69076] to-[#A69F97] p-6 sm:p-8 text-center">
              <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-2">
                Comece Agora Sem Custo!
              </h3>
              <p className="text-white/90 text-base sm:text-lg">
                Aproveite nossa oferta exclusiva de boas-vindas
              </p>
            </div>
            
            <CardContent className="p-6 sm:p-10">
              <div className="grid sm:grid-cols-2 gap-6 mb-8">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border-2 border-[#A69076]/50 hover:border-[#A69076] transition-all duration-300">
                  <div className="w-16 h-16 bg-[#A69076] rounded-full flex items-center justify-center mx-auto mb-4">
                    <Clock className="text-white" size={28} />
                  </div>
                  <h4 className="text-xl sm:text-2xl font-bold text-white mb-2">
                    {offers.main}
                  </h4>
                  <p className="text-base sm:text-lg text-[#F2F2F2]">
                    Receba um orçamento detalhado e transparente para seu projeto
                  </p>
                </div>
                
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border-2 border-[#A69076]/50 hover:border-[#A69076] transition-all duration-300">
                  <div className="w-16 h-16 bg-[#A69076] rounded-full flex items-center justify-center mx-auto mb-4">
                    <Shield className="text-white" size={28} />
                  </div>
                  <h4 className="text-xl sm:text-2xl font-bold text-white mb-2">
                    {offers.secondary}
                  </h4>
                  <p className="text-base sm:text-lg text-[#F2F2F2]">
                    Avaliação técnica profissional sem compromisso
                  </p>
                </div>
              </div>

              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 sm:p-8 mb-8 border border-[#A69076]/30">
                <h4 className="text-xl sm:text-2xl font-bold text-white mb-4 text-center">
                  O Que Você Recebe:
                </h4>
                <div className="grid sm:grid-cols-2 gap-3">
                  {[
                    'Análise completa da sua necessidade',
                    'Orientação sobre documentação necessária',
                    'Estimativa de prazos realista',
                    'Esclarecimento de todas as dúvidas',
                    'Plano de ação personalizado',
                    'Sem compromisso ou taxa oculta'
                  ].map((item, index) => (
                    <div key={index} className="flex items-start space-x-3">
                      <CheckCircle2 className="text-[#A69076] flex-shrink-0 mt-1" size={20} />
                      <span className="text-base sm:text-lg text-white">{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="text-center space-y-4">
                <Button 
                  asChild
                  size="lg"
                  className="bg-[#A69076] hover:bg-[#A69F97] text-white font-bold text-base sm:text-lg px-6 sm:px-10 py-6 sm:py-7 transition-all duration-300 shadow-xl hover:shadow-2xl w-full sm:w-auto"
                >
                  <a href={engineerInfo.whatsappLink} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center">
                    <span className="truncate">Falar no WhatsApp</span>
                    <ArrowRight className="ml-2 flex-shrink-0" size={24} />
                  </a>
                </Button>
                
                <p className="text-sm sm:text-base text-[#A69F97]">
                  Atendimento imediato!
                </p>
              </div>
            </CardContent>
          </Card>

          <div className="mt-10 text-center">
            <p className="text-base sm:text-lg text-[#073A40] mb-4">
              <strong className="text-[#A69076]">Atenção:</strong> Vagas limitadas para 
              atendimento personalizado. Garanta sua avaliação gratuita hoje mesmo!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfferSection;
